// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ec19d49b","455":"08b6088d","977":"d75a7f65"}[chunkId] + ".chunk.js";
};